// Sections that are not scoped to a selected customer.
//
// The header renders the customer breadcrumb and its tab bar off the selected
// customer in the store, which is route-agnostic. Without this list a customer
// picked earlier bleeds into the global pages, showing Profile/Connections tabs
// over a screen that has nothing to do with that customer.
export const GLOBAL_SECTIONS: Record<string, string> = {
  '/developer': 'Developer',
  '/institutions': 'Institutions',
  '/products': 'Products',
}

// Prefix match, so nested routes (e.g. /institutions/:institutionId) stay
// global too. Without this a detail page would fall back to being treated as
// customer-scoped and the bleed-through would return.
export const matchGlobalSection = (pathname: string): string | undefined =>
  Object.keys(GLOBAL_SECTIONS).find(
    path => pathname === path || pathname.startsWith(`${path}/`)
  )

export const isGlobalSection = (pathname: string): boolean =>
  matchGlobalSection(pathname) !== undefined

export const globalSectionLabel = (pathname: string): string | undefined => {
  const path = matchGlobalSection(pathname)
  return path ? GLOBAL_SECTIONS[path] : undefined
}

// Reverse lookup: section label -> its root route, for the breadcrumb link.
export const SECTION_ROOTS: Record<string, string> = Object.fromEntries(
  Object.entries(GLOBAL_SECTIONS).map(([path, label]) => [label, path])
)
